export default __webpack_public_path__ + "static/media/logout_icon.865f8f6a.svg";